
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ActualizarEstatusResponse, ActualizarSentenciaParams, BuscarSentenciasProps, defaultActualizarEstatus, defaultNuevaSentencia, defaultSentencia, NuevaSentenciaParams, GuardarNotificacionesParams, NuevaSentenciaResponse, DetalleSentenciaResponse } from '../../interfaces/sentencia/SentenciaInterface';

export const NuevaSentencia = ( params: NuevaSentenciaParams ) => {

    return new Promise<NuevaSentenciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Sentencia/NuevaSentencia', params, token)
            .then( ({ data } : { data : NuevaSentenciaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultNuevaSentencia, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const DetalleSentencia = ( id: string ) => {

    return new Promise<DetalleSentenciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Sentencia/DetalleSentencia/${ id }`, token)
            .then( ({ data } : { data : DetalleSentenciaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultSentencia, success: false, message: 'Ocurrio un error contacte con el administrador' });
            });

        }

    });

}

export const GuardarSentencia = ( params: ActualizarSentenciaParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Sentencia/GuardarSentencia/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultHttpResponse, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const ActualizarEstatusSentecia = ( params: ActualizarEstatusParams ) => {

    return new Promise<ActualizarEstatusResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Sentencia/ActualizarEstatus/', params, token)
            .then( ({ data } : { data : ActualizarEstatusResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultActualizarEstatus, message: 'Ocurrio un error contacte con el administrador' } );
            });

        }

    });

}

export const GuardarNotificaciones = ( params: GuardarNotificacionesParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Sentencia/GuardarNotificaciones/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const BuscarSentencias = ( id: number ) => {

    return new Promise<BuscarSentenciasProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Sentencia/BuscarSentencias/${ id }`, token)
            .then( ({ data } : { data : BuscarSentenciasProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}